module.exports = __webpack_public_path__ + "static/media/z0.1b841fec.JPG";